import React from 'react';
import Text from '../../../components/Text';
import Button from '../../../components/Button';
import Icon from '../../../components/Icon';
import Modal from '../../../components/Modal';
import { StyledButtonsContainer } from './styles';
import { IDessert } from '../../../models/IDessert';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getAuthenticatedToken } from '../../../redux/auth/index';
import { deleteDessertAsync } from '../../../redux/dessertSlice/thunks';

interface IRemoveDessertProps {
  selectedDessert?: IDessert;
  isOpent: boolean;
  setIsOpent: React.Dispatch<React.SetStateAction<boolean>>;
}

const RemoveDessert = ({ isOpent, setIsOpent, selectedDessert }: IRemoveDessertProps) => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(getAuthenticatedToken);

  const onDelete = () => {
    /* Fetch Send to Api */
    selectedDessert && selectedDessert?._id && dispatch(deleteDessertAsync({ dessertId: selectedDessert._id, token }));
    setIsOpent(false);
  };

  const onCancel = () => setIsOpent(false);

  return (
    <Modal size="md" isOpent={isOpent} setIsOpent={setIsOpent} data-testid="remove-dessert-modal">
      <Icon name="warning" />
      <Text type="body">¿Estás seguro que quieres eliminar este postre de la lista?</Text>
      <StyledButtonsContainer>
        <Button size="xs" variant="outline" onClick={() => onCancel()}>
          Cancelar
        </Button>
        <Button data-testid="button-test-delete" size="xs" onClick={() => onDelete()}>
          Eliminar
        </Button>
      </StyledButtonsContainer>
    </Modal>
  );
};

export default RemoveDessert;
